import React, { useState } from 'react';

import Media from 'react-media';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import CreateCustomMenu from './CreateCustomMenu';
import { BackLogoIconButton } from '../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText';
import { MobileTopHeader } from '../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader';
import { SliderReusableComponent } from '../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent';
import { clear_all_errors } from '../../../../../../../store/actions/errorActions';

function CreateCustomMenuOnboard(props) {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <CreateCustomMenu dash={false} />

          {/* <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              displayBarButton={true}
              displayHamburger={true}
              selectedProgressBarOne="active"
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require('../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-04.svg')}
            />
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
}

//export default CreateCustomMenuOnboard

CreateCustomMenuOnboard.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
})(withRouter(CreateCustomMenuOnboard));
